import { Paper, Stack, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';

import { useTranslation } from '@apple/lib/i18next';

import type { BudgetItem } from '@apple/features/store/components/BudgetSummary';

import { budgetQueryOptions } from '../queries/budget';
import { BudgetDetailsTable } from './BudgetDetailsTable';
import { BudgetPieChart } from './BudgetPieChart';

export interface BudgetDetailsProps {
	fiscalYear: number;
	singleStoreCustomerCode: string;
	periodNumber: number;
	budgetItems?: BudgetItem[];
}

export function BudgetDetails({
	fiscalYear,
	singleStoreCustomerCode,
	periodNumber,
	budgetItems,
}: BudgetDetailsProps) {
	const { t } = useTranslation('common');

	const budgetDetailsQuery = useQuery(
		budgetQueryOptions.budgetDetails(singleStoreCustomerCode, fiscalYear, periodNumber),
	);

	return budgetDetailsQuery.data && (budgetDetailsQuery.data?.length ?? 0) > 0 ? (
		<Stack m={0} gap={1}>
			<Stack>
				<Paper mt={'lg'} p={'xl'} withBorder={(budgetDetailsQuery.data?.length ?? 0) > 0}>
					<BudgetPieChart
						budgetDetailData={budgetDetailsQuery.data ?? []}
						isFetching={budgetDetailsQuery.isFetching}
						isLoading={budgetDetailsQuery.isLoading}
					/>
				</Paper>
				{periodNumber && (budgetDetailsQuery.data?.length ?? 0) > 0 && (
					<Paper mt={'lg'} withBorder={(budgetDetailsQuery.data?.length ?? 0) > 0}>
						<BudgetDetailsTable
							periodNumber={periodNumber}
							singleStoreCustomerCode={singleStoreCustomerCode}
							fiscalYear={fiscalYear}
							budgetDetailData={budgetDetailsQuery.data ?? []}
							isFetching={budgetDetailsQuery.isFetching}
							isLoading={budgetDetailsQuery.isLoading}
							budgetItems={budgetItems}
						/>
					</Paper>
				)}
			</Stack>
		</Stack>
	) : (
		<Stack align='center' justify='center'>
			<Title order={3}>{t('pagination.empty')}</Title>
		</Stack>
	);
}
